import Vue from 'vue'
import {
  Button,Toast,NoticeBar,Empty,
  Dialog,Overlay, Tabs,Tab,Search,Sticky,Lazyload,Swipe,SwipeItem,
  Grid,GridItem,Image,Icon,DropdownMenu, DropdownItem,Tag,Col, Row,
  Popup,Loading,List,ImagePreview
} from 'vant'
Vue.use(ImagePreview);
Vue.use(List);
Vue.use(Loading)
Vue.use(Col)
Vue.use(Row)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Tag)
Vue.use(DropdownMenu)
Vue.use(Tag)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Icon)
Vue.use(Image)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Empty)
Vue.use(Button)
Vue.use(Toast)
Vue.use(NoticeBar)
Vue.use(Dialog)
Vue.use(Overlay)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Search)
Vue.use(Sticky)
Vue.use(Popup);
Toast.setDefaultOptions({ duration: 2000 });
